import React, { useEffect } from 'react';
import useGAEventsTracker from '../../utils/useGAEventsTrackers';

// components
import Title from '../../components/Title';

// assets
import BankLogo from '../../assets/img/BankLogo.png';
import Button from '../../components/Button';
import { Img, ImgDiv, WrapperDiv } from './errorStyled';

function ErrorComponent() {
  const GAEventsTracker = useGAEventsTracker("Generic error");
  useEffect(() => {
    GAEventsTracker("Error generico");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRetry = () => {
    GAEventsTracker("Reintento");
    window.location.reload();
  };

  return (
    <WrapperDiv>
      <Title>
        La página no se encuentra disponible. Por favor, intente nuevamente más tarde.
      </Title>
      <ImgDiv>
        <Img src={BankLogo} />
      </ImgDiv>
      <Button filled grid="buttons" onClick={handleRetry}>
        Reintentar
      </Button>
    </WrapperDiv>
  );
}

export default ErrorComponent;
